import { z } from "zod";

export const UUID = z.uuid();
export type UUID = z.infer<typeof UUID>;
